import React from 'react'
import { BarChartSkeleton } from './BarChartSkeleton'

export const ChartLoading: React.FC = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <BarChartSkeleton />
    </div>
  )
}
